import React from 'react';

function EmptyTodos(){
    return (
     <p>Create you firts task ...</p>
    );
  }

  export { EmptyTodos};